<template>
  <div class="hiq-event-view__share">
    <span class="hiq-event-view__share--text">Dela</span>
    <a class="hiq-event-view__share--link facebook" :href="fbUrl" :style="accentColor">
      <span class="show-for-sr">Dela på Facebook</span>
      <span class="hiq-event-view__share--link__icon facebook" :style="color"></span>
    </a>
    <a class="hiq-event-view__share--link twitter" :href="twitterUrl" :style="accentColor">
      <span class="show-for-sr">Dela på Twitter</span>
      <span class="hiq-event-view__share--link__icon twitter" :style="color"></span>
    </a>
    <a class="hiq-event-view__share--link linkedIn" :href="linkedInUrl" :style="accentColor">
      <span class="show-for-sr">Dela på LinkedIn</span>
      <span class="hiq-event-view__share--link__icon linkedIn" :style="color"></span>
    </a>
    <a class="hiq-event-view__share--link mail" :href="mailUrl" :style="accentColor">
      <span class="show-for-sr">Dela via mejl</span>
      <span class="hiq-event-view__share--link__icon mail" :style="color"></span>
    </a>
  </div>
</template>

<script>

import Vue from "vue";

export default {
  name: "ShareEvent",

  computed: {
    event() { return this.$store.state.event },
    blockColor() { return this.$store.getters.blockColor },
    accentColor() { return this.$store.getters.accentColor },
    pageUrl() { return this.$store.state.pageUrl },
    fbUrl() { return 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(this.pageUrl + '?id=' + this.$store.getters.eventId) },
    twitterUrl() { return 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(this.pageUrl + '?id=' + this.$store.getters.eventId) },
    linkedInUrl() { return 'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(this.pageUrl + '?id=' + this.$store.getters.eventId)},
    mailUrl() {
      return 'mailto:' + '?subject=' + this.event.title + '&body=' + 'Hej!\n Länk till evenemang: ' + this.pageUrl + '?id=' + this.$store.getters.eventId
    },
    color() { return 'color:' + this.$store.state.blockColor + ';' }
  },

  methods: {
  },
};
</script>